{
  "CallControlMcError": "Il y a eu une erreur lors de la tentative de connexion à ",
  "CallControlActionError": "Il y a eu une erreur en essayant d'exécuter l'action ",
  "CallControlCompleteTransferError": "Une erreur s'est produite lors du transfert ",
  "CallControlPickupCallError": "Il y a eu une erreur dans la prise d'appel ",
  "CallControlChangingDndError": "Il y a eu une erreur dans le changement de statut DND pour ",
  "CallControlConnectionUpdate": "Il y a eu une erreur dans la mise à jour de la connexion ",
  "CallControlDeletePhantom": "Il y a eu une erreur en essayant de supprimer l'appel fantôme.",
  "CallControlAcdStatusUpdate": "Il y a eu une erreur dans la mise à jour du statut de l'ACD ",
  "CallControlMonitoringActionError": "Il y a eu une erreur dans l'action de suivi ",
  "CallControlUserInfoMissing": "Les informations sur l'utilisateur sont manquantes. Cela pourrait indiquer que vous n'êtes plus authentifié. Veuillez essayer de vous déconnecter et de vous reconnecter.",
  "CallControlTelPartDevError": "Le serveur de téléphonie, la partition, l'agent ou le dispositif n'étaient pas disponibles.",
  "NAME": "CallControlErrors",
  "CallControlSetAccountCode": "Une erreur s'est produite lors de la définition du code de compte."
}